import { fromJS, Map } from 'immutable';

import {
  OPEN_MODAL,
  CLOSE_MODAL,
  RESET_MODAL_STATE,
} from '../actions/actionTypes';

const initialState = fromJS({
  name: '',
  isOpen: false,
  props: {},
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return state
        .set('name', action.name)
        .set('isOpen', true)
        .set('props', fromJS(action.props));
    case CLOSE_MODAL:
      return state
        .set('isOpen', false)
        .set('props', Map({}))
        .set('name', '');
    case RESET_MODAL_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
